import {
  EventExhibitor,
  EventExhibitorsFilters,
  EventParticipationRequestType,
  PaginatedResponse,
  QueryArgs,
} from "@ac-expo/api-types";
import { useQuery } from "@tanstack/react-query";
import { privateAxios } from "../../axiosInstances";
import { eventsExhibitorsQueryKeys } from "../../query-keys";
import { EventParticipationRequestsQueryKeys } from "../../query-keys/participation-requests.query-keys";

const getEventRequestParticipations = async (eventId: string) => {
  const { data } = await privateAxios.get<EventParticipationRequestType[]>(
    `/events/${eventId}/exhibitors/requests`
  );
  return data;
};

export const useGetEventRequestParticipationsQuery = (eventId: string) => {
  return useQuery({
    queryKey: EventParticipationRequestsQueryKeys.event(eventId),
    queryFn: () => getEventRequestParticipations(eventId),
  });
};

const getEventExhibitor = async (eventId: string, exhibitorId = "me") => {
  const { data } = await privateAxios.get<EventExhibitor>(
    `/events/${eventId}/exhibitors/${exhibitorId}`
  );
  return data;
};

export const useGetEventExhibitorQuery = (
  eventId: string,
  exhibitorId?: string
) => {
  return useQuery({
    queryKey: eventsExhibitorsQueryKeys.detail(eventId, exhibitorId ?? "me"),
    queryFn: () => getEventExhibitor(eventId, exhibitorId),
  });
};

const getEventExhibitors = async (
  eventId: string,
  filters?: EventExhibitorsFilters
) => {
  const { data } = await privateAxios.get<PaginatedResponse<EventExhibitor>>(
    `/events/${eventId}/exhibitors`,
    filters ? { params: filters } : undefined
  );
  return data;
};

export const useGetEventExhibitorsQuery = (
  eventId: string,
  filters?: EventExhibitorsFilters,
  options?: QueryArgs<PaginatedResponse<EventExhibitor>>
) => {
  return useQuery({
    queryKey: eventsExhibitorsQueryKeys.filteredList(eventId, filters ?? {}),
    queryFn: () => getEventExhibitors(eventId, filters),
    ...options,
  });
};
